// SPDX-FileCopyrightText: 2017-2026 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

export { faArrowDown as fasArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown'
export { faArrowUp as fasArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp'
export { faCalendar as fasCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar'
export { faCaretDown as fasCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown'
export { faCaretLeft as fasCaretLeft } from '@fortawesome/free-solid-svg-icons/faCaretLeft'
export { faCaretRight as fasCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight'
export { faCaretUp as fasCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp'
export { faCheckCircle as fasCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
export { faChevronDown as fasChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
export { faChevronUp as fasChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp'
export { faChild as fasChild } from '@fortawesome/free-solid-svg-icons/faChild'
export { faEnvelope as fasEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
export { faExclamation as fasExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation'
export { faExclamationTriangle as fasExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
export { faInfo as fasInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
export { faMapMarkerAlt as fasMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
export { faUser as fasUser } from '@fortawesome/free-solid-svg-icons/faUser'
export { faUserMinus as fasUserMinus } from '@fortawesome/free-solid-svg-icons/faUserMinus'
export { faAbacus } from '@fortawesome/pro-light-svg-icons/faAbacus'
export { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown'
export { faAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft'
export { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight'
export { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp'
export { faArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowDown'
export { faArrowDownToLine } from '@fortawesome/pro-light-svg-icons/faArrowDownToLine'
export { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft'
export { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
export { faArrowUp } from '@fortawesome/pro-light-svg-icons/faArrowUp'
export { faArrowRotateLeft } from '@fortawesome/pro-light-svg-icons/faArrowRotateLeft'
export { faArrowsRotate } from '@fortawesome/pro-light-svg-icons/faArrowsRotate'
export { faBabyCarriage } from '@fortawesome/pro-light-svg-icons/faBabyCarriage'
export { faBell } from '@fortawesome/pro-light-svg-icons/faBell'
export { faBellSlash } from '@fortawesome/pro-light-svg-icons/faBellSlash'
export { faBars } from '@fortawesome/pro-light-svg-icons/faBars'
export { faBarsSort } from '@fortawesome/pro-solid-svg-icons/faBarsSort'
export { faBoxArchive } from '@fortawesome/pro-solid-svg-icons/faBoxArchive'
export { faCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar'
export { faCalendarAlt } from '@fortawesome/pro-light-svg-icons/faCalendarAlt'
export { faCalendarPlus } from '@fortawesome/pro-light-svg-icons/faCalendarPlus'
export { faCalendarTimes } from '@fortawesome/pro-light-svg-icons/faCalendarTimes'
export { faCar } from '@fortawesome/pro-light-svg-icons/faCar'
export { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
export { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle'
export { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'
export { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft'
export { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
export { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp'
export { faChild } from '@fortawesome/pro-light-svg-icons/faChild'
export { faCircleEllipsis } from '@fortawesome/pro-solid-svg-icons/faCircleEllipsis'
export { faCircleEllipsisVertical } from '@fortawesome/pro-solid-svg-icons/faCircleEllipsisVertical'
export { faCircleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation'
export { faClock } from '@fortawesome/pro-light-svg-icons/faClock'
export { faCoins } from '@fortawesome/pro-light-svg-icons/faCoins'
export { faComment } from '@fortawesome/pro-light-svg-icons/faComment'
export { faComment as fasComment } from '@fortawesome/pro-solid-svg-icons/faComment'
export { faCommentAlt } from '@fortawesome/pro-light-svg-icons/faCommentAlt'
export { faComments } from '@fortawesome/pro-light-svg-icons/faComments'
export { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy'
export { faDatabase } from '@fortawesome/pro-light-svg-icons/faDatabase'
export { faDash } from '@fortawesome/pro-light-svg-icons/faDash'
export { faDiagnoses } from '@fortawesome/pro-light-svg-icons/faDiagnoses'
export { faDownLeftAndUpRightToCenter } from '@fortawesome/pro-light-svg-icons/faDownLeftAndUpRightToCenter'
export { faEllipsisVAlt } from '@fortawesome/pro-light-svg-icons/faEllipsisVAlt'
export { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope'
export { faEuroSign } from '@fortawesome/pro-light-svg-icons/faEuroSign'
export { faExchange } from '@fortawesome/pro-light-svg-icons/faExchange'
export { faExclamation } from '@fortawesome/pro-light-svg-icons/faExclamation'
export { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle'
export { faExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink'
export { faEye } from '@fortawesome/pro-light-svg-icons/faEye'
export { faEyeSlash } from '@fortawesome/pro-light-svg-icons/faEyeSlash'
export { faFemale } from '@fortawesome/pro-light-svg-icons/faFemale'
export { faFile } from '@fortawesome/pro-light-svg-icons/faFile'
export { faFile as fasFile } from '@fortawesome/pro-solid-svg-icons/faFile'
export { faFileAlt } from '@fortawesome/pro-light-svg-icons/faFileAlt'
export { faFileAlt as fasFileAlt } from '@fortawesome/pro-solid-svg-icons/faFileAlt'
export { faFileExport } from '@fortawesome/pro-light-svg-icons/faFileExport'
export { faFileImage } from '@fortawesome/pro-light-svg-icons/faFileImage'
export { faFileImport } from '@fortawesome/pro-light-svg-icons/faFileImport'
export { faFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf'
export { faFileSpreadsheet } from '@fortawesome/pro-light-svg-icons/faFileSpreadsheet'
export { faFileWord } from '@fortawesome/pro-light-svg-icons/faFileWord'
export { faGavel } from '@fortawesome/pro-light-svg-icons/faGavel'
export { faGear } from '@fortawesome/pro-light-svg-icons/faGear'
export { faGear as fasGear } from '@fortawesome/pro-solid-svg-icons/faGear'
export { faGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe'
export { faHandHolding } from '@fortawesome/pro-light-svg-icons/faHandHolding'
export { faHiking } from '@fortawesome/pro-light-svg-icons/faHiking'
export { faHome } from '@fortawesome/pro-light-svg-icons/faHome'
export { faHourglassEnd } from '@fortawesome/pro-light-svg-icons/faHourglassEnd'
export { faHourglassStart } from '@fortawesome/pro-light-svg-icons/faHourglassStart'
export { faInfo } from '@fortawesome/pro-light-svg-icons/faInfo'
export { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle'
export { faKey } from '@fortawesome/pro-light-svg-icons/faKey'
export { faLaptop } from '@fortawesome/pro-light-svg-icons/faLaptop'
export { faLink } from '@fortawesome/pro-light-svg-icons/faLink'
export { faList } from '@fortawesome/pro-light-svg-icons/faList'
export { faLockAlt } from '@fortawesome/pro-light-svg-icons/faLockAlt'
export { faLockOpenAlt } from '@fortawesome/pro-light-svg-icons/faLockOpenAlt'
export { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt'
export { faMeh } from '@fortawesome/pro-light-svg-icons/faMeh'
export { faMobileButton } from '@fortawesome/pro-light-svg-icons/faMobileButton'
export { faMoneyBillWave } from '@fortawesome/pro-light-svg-icons/faMoneyBillWave'
export { faMoneyCheck } from '@fortawesome/pro-light-svg-icons/faMoneyCheck'
export { faMoneyCheckEdit } from '@fortawesome/pro-light-svg-icons/faMoneyCheckEdit'
export { faPaperclip } from '@fortawesome/pro-light-svg-icons/faPaperclip'
export { faPen } from '@fortawesome/pro-light-svg-icons/faPen'
export { faPercentage } from '@fortawesome/pro-light-svg-icons/faPercentage'
export { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
export { faPlay } from '@fortawesome/pro-light-svg-icons/faPlay'
export { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus'
export { faPlusCircle } from '@fortawesome/pro-light-svg-icons/faPlusCircle'
export { faPrint } from '@fortawesome/pro-light-svg-icons/faPrint'
export { faQuestion } from '@fortawesome/pro-light-svg-icons/faQuestion'
export { faQuestionCircle } from '@fortawesome/pro-light-svg-icons/faQuestionCircle'
export { faRedo } from '@fortawesome/pro-light-svg-icons/faRedo'
export { faRefresh } from '@fortawesome/pro-light-svg-icons/faRefresh'
export { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch'
export { faSection } from '@fortawesome/pro-light-svg-icons/faSection'
export { faSignIn } from '@fortawesome/pro-light-svg-icons/faSignIn'
export { faSignOut } from '@fortawesome/pro-light-svg-icons/faSignOut'
export { faStickyNote } from '@fortawesome/pro-light-svg-icons/faStickyNote'
export { faSync } from '@fortawesome/pro-light-svg-icons/faSync'
export { faTabletButton } from '@fortawesome/pro-light-svg-icons/faTabletButton'
export { faThermometer } from '@fortawesome/pro-light-svg-icons/faThermometer'
export { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes'
export { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash'
export { faTreePalm } from '@fortawesome/pro-light-svg-icons/faTreePalm'
export { faTruck } from '@fortawesome/pro-light-svg-icons/faTruck'
export { faUndo } from '@fortawesome/pro-light-svg-icons/faUndo'
export { faUpRightAndDownLeftFromCenter } from '@fortawesome/pro-light-svg-icons/faUpRightAndDownLeftFromCenter'
export { faUser } from '@fortawesome/pro-light-svg-icons/faUser'
export { faUser as farUser } from '@fortawesome/pro-light-svg-icons/faUser'
export { faUserAltSlash } from '@fortawesome/pro-light-svg-icons/faUserAltSlash'
export { faUserFriends } from '@fortawesome/pro-light-svg-icons/faUserFriends'
export { faUserMinus } from '@fortawesome/pro-light-svg-icons/faUserMinus'
export { faUserUnlock } from '@fortawesome/pro-light-svg-icons/faUserUnlock'
export { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers'
export { faBan as farBan } from '@fortawesome/pro-regular-svg-icons/faBan'
export { faBars as farBars } from '@fortawesome/pro-regular-svg-icons/faBars'
export { faBellSlash as farBellSlash } from '@fortawesome/pro-regular-svg-icons/faBellSlash'
export { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle'
export { faFileAlt as farFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt'
export { faMap as farMap } from '@fortawesome/pro-regular-svg-icons/faMap'
export { faGavel as farGavel } from '@fortawesome/pro-regular-svg-icons/faGavel'
export { faSignOut as farSignOut } from '@fortawesome/pro-regular-svg-icons/faSignOut'
export { faStickyNote as farStickyNote } from '@fortawesome/pro-regular-svg-icons/faStickyNote'
export { faUsers as farUsers } from '@fortawesome/pro-regular-svg-icons/faUsers'
export { faXmark as farXmark } from '@fortawesome/pro-regular-svg-icons/faXmark'
export { faCommentAltLines as fasCommentAltLines } from '@fortawesome/pro-solid-svg-icons/faCommentAltLines'
export { faMagnifyingGlassPlus } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlassPlus'
export { faMagnifyingGlassMinus } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlassMinus'
export { faListTimeline } from '@fortawesome/pro-light-svg-icons/faListTimeline'
export { faReply } from '@fortawesome/pro-light-svg-icons/faReply'
export { faUtensils } from '@fortawesome/pro-light-svg-icons/faUtensils'
export { faLineChart } from '@fortawesome/pro-light-svg-icons/faLineChart'
export { faHeart } from '@fortawesome/pro-light-svg-icons/faHeart'

import type * as ProIconsSet from './pro-icons'
import { typeAssert } from './utils'

import type { IconSet } from '.'

typeAssert<typeof ProIconsSet extends IconSet ? true : false>(true)
